<template>
  <div>
   <button @click="openAddNewUserModal" id="add-new-user">+</button>
    <b-modal
      hide-footer
      size="xl"
      centered
      ref="add-user-modal"
      id="add-user-modal"
      :title="titleModal"
      >
      <template #modal-title>
          <div class="header-title">{{titleModal}}</div>
      </template>
      <b-form v-on:submit.prevent="onSubmit">
        <div class="container-user-form">
          <div class="title-1 title">Dados Básicos</div>
          <b-form-group
            id="input-group-name"
            label="Nome:"
            label-for="input-name"
          >
            <b-form-input
              id="input-name"
              name="input-name"
              type="text"
              v-validate="{ alpha_spaces: true, required: true }"
              :state="validateState('input-name')"
              v-model="newUserData.nome"
              placeholder="Digite o nome do usuário"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-email"
            label="E-mail:"
            label-for="input-email"
          >
            <b-form-input
              id="input-email"
              name="input-email"
              v-validate="{ required: true, email: true }"
              :state="validateState('input-email')"
              v-model="newUserData.email"
              type="email"
              placeholder="Digite o e-mail do usuário"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-dateBirth"
            label="Data de Nascimento:"
            label-for="input-dateBirth"
          >
            <b-form-input
              id="input-dateBirth"
              name="dateBirth"
              required
              :type="'date'"
              v-model="newUserData.dataNascimento"
              :placeholder="$lang.Common.DatePlaceholder"
              v-validate="{ required: true }"
              :state="validateState('dateBirth')"
            ></b-form-input>

          </b-form-group>

          <b-form-group
            v-if="showCreci"
            id="input-group-creci"
            label="CRECI:"
            label-for="input-creci"
          >
            <b-form-input
              id="input-creci"
              name="input-creci"
              v-model="newUserData.creci"
              v-validate="{ required: true }"
              :state="validateState('input-creci')"
              type="text"
              placeholder="Digite o número do CRECI"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            v-if="showCreci"
            id="input-group-uf-creci"
            label="UF CRECI:"
            label-for="input-uf-creci"
          >
            <b-form-select
              id="input-uf-creci"
              name="input-uf-creci"
              :options="statesAcronym"
              v-validate="{ required: true }"
              :state="validateState('input-uf-creci')"
              v-model="newUserData.ufCreciId"
              type="text"
              placeholder="Selecione"
              required
            ></b-form-select>
          </b-form-group>

          <b-form-group id="input-group-percentage"
            v-if="false"
            label="Percentual de comissão:"
            label-for="input-percentage">
            <b-form-input
              id="input-percentage"
              name="input-percentage"
              v-model="newUserData.percentualComissao"
              v-validate="{ required: true }"
              v-on:blur="formatLazyPercentage"
              :state="validateState('input-percentage')"
              type="text"
              placeholder="Percentual de comsissão"
              required
              :formatter="formatPercentage"
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-rg" label="RG:" label-for="input-rg" :class="showCreci ? '':'input-rg-administrator'">
            <b-form-input
              id="input-rg"
              name="input-rg"
              v-model="newUserData.rg"
              v-validate="{ required: true }"
              :state="validateState('input-rg')"
              type="text"
              placeholder="Digite o RG do usuário"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-cpf" label="CPF:" label-for="input-cpf" :class="showCreci ? '':'input-cpf-administrator'">
            <b-form-input
              id="input-cpf"
              name="input-cpf"
              v-model="newUserData.cpf"
              v-validate="{ required: true, length: 14, numeric: false }"
              :state="validateState('input-cpf')"
              type="text"
              placeholder="___.___.___-__"
              required
              v-mask="['###.###.###-##']"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-cellphone"
            label="Celular:"
            label-for="input-cellphone"
          >
            <b-form-input
              id="input-cellphone"
              name="input-cellphone"
              v-model="newUserData.celular"
              v-validate="{ required: true, numeric: false, length: 15 }"
              :state="validateState('input-cellphone')"
              type="text"
              placeholder="(__) _____-____"
              v-mask="['(##) #####-####']"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-comercial-phone"
            label="Telefone Comercial:"
            label-for="input-comercial-phone"
          >
            <b-form-input
              id="input-comercial-phone"
              name="input-comercial-phone"
              v-model="newUserData.telefoneComercial"
              v-validate="{ required: true, numeric: false, length:14 }"
              :state="validateState('input-comercial-phone')"
              type="text"
              placeholder="(__) ____-____"
              v-mask="['(##) ####-####']"
              required
            ></b-form-input>
          </b-form-group>

          <div class="title-2">Endereço</div>
          <b-form-group id="input-group-cep" label="CEP:" label-for="input-cep">
            <b-form-input
              id="input-cep"
              name="input-cep"
              v-model="newUserData.cep"
              v-on:blur="searchAndress"
              v-validate="{ required: true, numeric: false, length: 9 }"
              :state="validateState('input-cep')"
              type="text"
              placeholder="_____-___"
              v-mask="['#####-###']"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-city"
            label="Cidade:"
            label-for="input-city"
          >
            <b-form-input
              id="input-city"
              name="input-city"
              v-model="newUserData.cidade"
              v-validate="{ required: true, alpha_spaces: true }"
              :state="validateState('input-city')"
              type="text"
              placeholder="Digite o nome da cidade"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-address"
            label="Endereço:"
            label-for="input-address"
          >
            <b-form-input
              id="input-address"
              name="input-address"
              v-model="newUserData.endereco"
              v-validate="{ required: true, alpha_spaces:true }"
              :state="validateState('input-address')"
              type="text"
              placeholder="Digite o endereço do usuário"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-district"
            label="Bairro:"
            label-for="input-district"
          >
            <b-form-input
              id="input-district"
              name="input-district"
              v-model="newUserData.bairro"
              v-validate="{ required: true, alpha_spaces: true }"
              :state="validateState('input-district')"
              type="text"
              placeholder="Digite o endereço do usuário"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="input-group-number"
            label="Número:"
            label-for="input-number"
          >
            <b-form-input
              id="input-number"
              name="input-number"
              v-model="newUserData.numero"
              v-validate="{ required: true }"
              :state="validateState('input-number')"
              type="text"
              placeholder="Digite o número do usuário"
              required
            ></b-form-input>
          </b-form-group>

          <div class="container-buttons-form">
            <button @click="cancelNewUser" class="button-cancel">
              Cancelar
            </button>
            <button class="button-save">Salvar</button>
          </div>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import UserAddModal from '@/views/private/realestate/users/components/UserAddModal/UserAddModal.js'
export default UserAddModal
</script>

<style scoped>
.header-title{
  color: white;
}
#add-new-user{
    font-size: 28px;
    background-color: #008144;
    outline: transparent;
    color:white;
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border:transparent
}

.container-modal{
  position: fixed;
  bottom: calc(50px - 1vh);
  right: 10px;
}

.container-user-form{
    display: grid;
    column-gap: 10px;
    row-gap: 10px;
    justify-content: center;
    grid-template-rows: 10% 1fr 1fr 10% 1fr 1fr;
    grid-template-columns: repeat(10,1fr);
}

#input-group-name{
    grid-row: 2;
    grid-column: 1/5;
}

#input-group-email{
    grid-row: 2;
    grid-column: 5/8;
}

#input-group-dateBirth{
    grid-row: 2;
    grid-column:  8/11;
}

#input-group-creci{
    grid-row: 3;
    grid-column: 1;
}
#input-group-uf-creci{
    grid-row: 3;
    grid-column: 2;
}
#input-group-percentagee{
  grid-row: 3;
  grid-column: 3/4;
}
#input-group-rg{
    grid-row: 3;
    grid-column: 3/5;
}
#input-group-cpf{
    grid-row: 3;
    grid-column: 5/7;
}
#input-group-cellphone{
    grid-row: 3;
    grid-column: 7/9;
}
#input-group-comercial-phone{
    grid-row: 3;
    grid-column: 9/11;
}
#input-group-cep{
    grid-row: 5;
    grid-column: 1;
}
#input-group-city{
    grid-row: 5;
    grid-column: 2/4;
}
#input-group-address{
    grid-row: 5;
    grid-column: 4/8;
}
#input-group-district{
    grid-row: 5;
    grid-column: 8/10;
}

#input-group-number{
    grid-row: 5;
    grid-column: 10;
}

.container-buttons-form{
    grid-row: 6;
    grid-column: 1/11;
}

.title-1,
.title-2{
    color: #008148;
}

.title-1{
  grid-row: 1;
}

.title-2{
  grid-row: 4;
}

.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-save{
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}
.button-cancel{
  background-color: #dedede;
  color: #747474;
}
.button-save{
  background-color: #008148;
  color: white;

}

/* estilização do cabeçalho do popup */

.container-hearder{
  background-color: #008144;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  padding: 25px 0;
}

.title-hearder{
  color: white;
  grid-column: 1;
  grid-row: 1;
  text-transform: uppercase;
  justify-self: center;
}

.container-close-button{
  grid-column: 1;
  grid-row: 1;
  justify-self: end;
  align-self: center;
}

.container-close-button img{
  width: 32px;
}

.input-rg-administrator{
  grid-column: 1/4 !important;
}

.input-cpf-administrator{
  grid-column: 4/7 !important;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/users/components/UserAddModal/UserAddModal.vue